/* global Word */

export async function handleRemoveElement(startElement: Word.Paragraph) {
  startElement.delete();
}
